import { loadScripts } from 'load-resource-dynamically'
import mainNav from '@pds/layouts/main-nav/'

import { browser, lazyLoad, radioGroup, offCanvas } from './utils/'

const lazyLoadAllOnce = (function () {
  let called = false
  return () => {
    if (!called) {
      window.jQuery('.js-lazy-load').each((index, el) => lazyLoad(el))
      called = true
    }
  }
}())

if (!browser.supportsTouch) {
  document.documentElement.classList.add('browser-no-touch-support')
}

window.paceOptions = {
  ajax: true,
  document: true,
  eventLag: true
}

// called after polyfill.io is done
window.PDS.afterPolyfill = function () {
  window.addEventListener('DOMContentLoaded', () => {
    loadScripts(['https://cdnjs.cloudflare.com/ajax/libs/svg4everybody/2.1.9/svg4everybody.min.js']).then(() => {
      lazyLoadAllOnce()
      svg4everybody()
    })
  }, false)
}

document.addEventListener('DOMContentLoaded', () => {
  mainNav()
  radioGroup(window.jQuery)
  offCanvas()
  lazyLoadAllOnce()
})
